module.exports = __webpack_public_path__ + "assets/img/userAccountBg.9c47b0a2.png";